import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11'


class OpenFlagEditor extends React.Component {
  render() {
    // ViewModeコンポーネントに、Rails View の 'react_component' タグで引き渡されたデータを渡す
    // （これらのデータは、それぞれのコンポーネントで 'props' 経由でアクセスできる）
    return (
      <EditMode
        member={this.props.member}
        update_url={this.props.update_url}
        profile_url={this.props.profile_url}
        csrf_token={this.props.csrf_token}
      />
    );
  }
}

class EditMode extends React.Component {
  // コンストラクタ
  constructor(props) {
    super(props);
    this.state = { member: JSON.parse(JSON.stringify(this.props.member)) };
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleClick(e) {
    // デフォルト動作の解除
    e.preventDefault();
    // メッセージエリアをクリア
    var message_area = document.querySelector('div.message_area.profile');
    while (message_area.firstChild) {
      message_area.removeChild(message_area.firstChild);
    }
    // ボタン非活性
    let elements = document.querySelectorAll('.btn_target');
    elements.forEach(function (element) {
      element.classList.add('btn_disabled');
    });
    // membersの更新
    fetch(this.props.update_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.props.csrf_token
      },
      body: JSON.stringify({ member: { open_flag: this.state.member.open_flag }, authenticity_token: this.props.csrf_token })
    }).then((res) => {
      return res.json();
    }).then((data) => {
      if (data.status == 200) {
        // 変更された項目があるとき
        if (Object.keys(data.saved_changes).length !== 0) {
          // 更新メッセージ表示
          const node = document.createElement('p');
          const message = document.createTextNode('プロフィールを更新しました。');
          node.appendChild(message);
          document.querySelector('div.message_area.profile').appendChild(node);
        }
      } else if (data.status == 400) {
        // エラーメッセージ表示
        const node = document.createElement('p');
        // とりあえずエラーメッセージは一つだけ表示させるとのこと
        const message = document.createTextNode(data.errors[0]);
        node.appendChild(message);
        document.querySelector('div.message_area.profile').appendChild(node);

        // チェックボックスの状態を戻す
        this.state.member.open_flag = data.prev_open_flag
      }
      ReactDOM.render(
        <EditMode
          member={JSON.parse(JSON.stringify(this.state.member))}
          update_url={this.props.update_url}
          profile_url={this.props.profile_url}
          csrf_token={this.props.csrf_token}
        />,
        document.getElementById('open_flag_area')
      );

      // ボタン活性
      let elements = document.querySelectorAll('.btn_target');
      elements.forEach(function (element) {
        element.classList.remove('btn_disabled');
      });
    }).catch((err) => {
      console.error(err);
    });
  }

  handleChange(e) {
    var member = this.state.member;
    switch (e.target.id) {
      case 'radio-01':
        member.open_flag = 1;
        break;
      case 'radio-02':
        member.open_flag = 2;
    }
    // 状態を更新
    this.setState({ member: member });
  }

  render() {
    function OpenFlagTag(props) {
      if (props.open_flag == 1) {
        return <span className="open_flag fs-75">公開中</span>;
      } else if (props.open_flag == 2) {
        return <span className="open_flag fs-75">非公開</span>;
      }
    }
    return (
      <React.Fragment>
        <h2 className="profile">
          <span className="label fs-113-custom">プロフィール</span>
          <OpenFlagTag open_flag={this.props.member.open_flag} />
        </h2>
        <p className="arrow"><a href={this.props.profile_url}>プロフィール画面を確認</a></p>
        <div className="input_area">
          <ul>
            <li>
              <input id="radio-01" name="customRadio" type="radio" className="radio-input" value="1" onChange={this.handleChange} checked={this.state.member.open_flag == 1} />
              <label htmlFor="radio-01" className="fs-88">プロフィールを公開する</label>
            </li>
            <li>
              <input id="radio-02" name="customRadio" type="radio" className="radio-input" value="2" onChange={this.handleChange} checked={this.state.member.open_flag == 2} />
              <label htmlFor="radio-02" className="fs-88">プロフィールを公開しない</label>
            </li>
            <p>※「プロフィールを公開しない」を設定した場合、掲示板の記事投稿・編集ができなくなります。</p>
          </ul>
          <div className="btn_right">
            <a href="" className="fs-75 btn_target" onClick={this.handleClick}>更新</a>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
OpenFlagEditor.propTypes = { member: PropTypes.object }

export default OpenFlagEditor
